<sera-popup
    [(display)]="displayUserSearchPopup"
    [allowOverflow]="true"
    headerText="{{ 'PAGE.USERSEARCH.USER_SEARCH_TITLE.TXT' | translate }}"
    (popupHidden)="closeDialog()">
    <form
        [formGroup]="userSearchParamsForm"
        (submit)="searchUser()">
        <div class="user-search-form">
            <sera-input-text
                formControlName="lastName"
                label="{{ 'PAGE.USERADMIN.LASTNAME.LBL' | translate }}"
                style="width: 300px"
                class="user-search-form__last-name"></sera-input-text>
            <sera-input-text
                formControlName="firstName"
                label="{{ 'PAGE.USERADMIN.FIRSTNAME.LBL' | translate }}"
                style="width: 300px"
                class="user-search-form__first-name"></sera-input-text>
            <sera-input-text
                formControlName="plantCCDC"
                label="{{ 'PAGE.MASTERDATA.PLANT_CC_DC.LBL' | translate }}"
                style="width: 300px"
                class="user-search-form__ccdc"></sera-input-text>
            <sera-input-text
                formControlName="mail"
                label="{{ 'PAGE.USERADMIN.EMAIL.LBL' | translate }}"
                style="width: 300px"
                class="user-search-form__email"></sera-input-text>
            <sera-input-text
                formControlName="qNumber"
                label="{{ 'PAGE.USERADMIN.QNUMBER.LBL' | translate }}"
                style="width: 300px"
                class="user-search-form__qnumber"></sera-input-text>
            <div class="user-search-form__restrict-and-search">
                <sera-checkbox
                    [isDisabled]="true"
                    formControlName="restrictSearchSeraUsers"
                    label="{{ 'PAGE.USERSEARCH.RESTRICT_ON_INTERNAL_USER.LBL' | translate }}"></sera-checkbox>
                <sera-button
                    icon="ci ci--white ci-search"
                    styleClass="sera-round-button"
                    [isFormSubmitButton]="true"></sera-button>
            </div>
        </div>
    </form>

    <div class="table-container">
        <sera-table
            [content]="userSearchTableContent"
            [isLoading]="isTableLoading"
            [onlyTitleHeader]="true"
            [header]="false"></sera-table>
    </div>

    <div class="sera-popup-footer">
        <ds-button
            [variant]="'ghost'"
            (click)="closeDialog()"
            (keydown.enter)="closeDialog()">
            {{ 'PAGE.GENERAL.CLOSE.BT' | translate }}
        </ds-button>
    </div>
</sera-popup>
